import React from "react";
import './Button.css';
import { useNavigate } from 'react-router-dom';


const FeaturedRecipBut = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/admin');
    };

    return (
        <button className="featuredRecip-button" onClick={handleClick}>
            Featured Recipes
        </button>
    );
}
export default FeaturedRecipBut;